<h3 class="overline-o2 secondary-text mb-0 inline-block m-6">{{'billing.billingData' | translate }}</h3>
<app-billing-data *ngIf="organization" [organization]="organization" [isBackOffice]="true"></app-billing-data>
<div class="mt-10">
  <hr class="divider ml-0 w-1/3">
</div>
<app-usages *ngIf="organization" [organization]="organization" [isBackOffice]="true"></app-usages>

